// extracted by mini-css-extract-plugin
module.exports = {"quickFilter":"RestaurantHomeFilters_quickFilter___zJh_","quickFilterTitle":"RestaurantHomeFilters_quickFilterTitle__fZhrY"};